// ВНИМАНИЕ, КОСТЫЛЬ, взятый по ссылке
// https://stackoverflow.com/questions/2388164/set-focus-on-div-contenteditable-element
// Нужен для фокуса именно на элементе значения ячейки, минуя валюту и другие элементы родительского элемента
// Айдишник генерится как составной ключ из ключа столбца и айдишника строки

const rangeFocusHandler = (id) => {
  const p = document.getElementById(id);
  const s = window.getSelection();
  const r = document.createRange();
  r.setStart(p, 0);
  r.setEnd(p, 1);
  s.removeAllRanges();
  s.addRange(r);
  return p;
};

export default rangeFocusHandler;
